import React from "react";
import "./styles.scss";
import AlbumSquareTag from "./AlbumSquareTag";
import moment from "moment";

export default ({ album }) => {
  return (
    <div id="album">
      <div className="media">
        <AlbumSquareTag album={album} className="mr-5" />
        <div className="media-body">
          <h5>
            <b>{album.title}</b>
          </h5>
          <p className="mb-1">{album.user.username}</p>
          {album.featured_artists && album.featured_artists.length > 0 && (
            <p className="light">
              Featuring {album.featured_artists.join(",")}
            </p>
          )}
          {album.release_date && (
            <div className="mt-3">
              <small className="album-release-date">
                Released on: {moment(album.release_date).format("MMMM DD, YYYY")}
              </small>
            </div>
          )}
        </div>
      </div>
      {album.description && (
        <p className="album-description light mt-3">{album.description}</p>
      )}
    </div>
  );
};
